import React, { Component } from "react";


import './LogoLoader.scss';
import { Logo } from "./Logo.jsx";

export default class LogoLoader extends React.Component {


    static defaultProps = {
        zIndex: 55,
        visible: false,
        opacity: false,
        noOpacity: false,
        delay: true,
        fixed: false,
    }


    render() {

        var { zIndex, visible, className = '', text = '' } = this.props;

        var styles = {
            display: visible ? "block" : "none",
            zIndex: zIndex,
        };





        return (
            <div
                className={'LogoLoader ' + className}
                style={styles}
            >
                <div className="Loader__loader">
                    <Logo />
                    {text ? <div className="LogoLoader__text">{text}</div> : null}

                </div>
            </div>
        );
    }
}

